import { createFileRoute } from "@tanstack/react-router";
import { SubcontractingSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/subcontracting")({
  component: SubcontractingSettingsPage,
});
